module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/step01-649e842e8b3c51e03550a6fef5b45ecc.png";